// knife-legal-disclaimer-form.liquid
// knife-legal-terms-modal.liquid
// knife-legal-disclaimer-form.js

  document.addEventListener('DOMContentLoaded', function () {
    
      var modal_lt = document.querySelector('.terms-popup-modal');
      var closeButtonLT = document.querySelector('.close-legal-terms');
      var openLegalTerms = document.querySelector('.open-legal-terms');
  
      // Open the modal_lt
      function openModalLT() {
          modal_lt.style.display = 'block';
      }
    
      // Close the modal_lt
      function closeModalLT() {
          modal_lt.style.display = 'none';
      }
    
      // Close modal_lt when clicking outside of it
      window.addEventListener('click', function (event) {
          if (event.target == modal_lt) {
              closeModalLT();
          }
      });
      // Close modal_lt when clicking on close button
      if(closeButtonLT){
        closeButtonLT.addEventListener('click', function () {
            closeModalLT();
          });
      }
      if(openLegalTerms){
          openLegalTerms.addEventListener('click', function () {
            openModalLT();
          });
      }
  });